export default "__VITE_ASSET__d71dba2b__"